import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-project-award',
  templateUrl: './project-award.component.html',
  styleUrls: ['./project-award.component.css']
})
export class ProjectAwardComponent implements OnInit {
   workOrderForm!: FormGroup;
  mode: 'add' | 'edit' | 'view' = 'add'; // change as needed

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();

    if (this.mode === 'edit' || this.mode === 'view') {
      this.loadData(); // simulate loading
    }

    if (this.mode === 'view') {
      this.workOrderForm.disable(); // disable form in view mode
    }
  }

  initializeForm() {
    this.workOrderForm = this.fb.group({
      client: this.fb.group({
        name: ['', Validators.required],
        address: [''],
      }),
      vendor: this.fb.group({
        name: ['', Validators.required],
        address: [''],
        gstin: [''],
        pan: [''],
      }),
      items: this.fb.array([]), // initially empty
      summary: this.fb.group({
        subTotal: [''],
        cgst: [''],
        sgst: [''],
        igst: [''],
        total: [''],
      }),
    });
  }

  get items(): FormArray {
    return this.workOrderForm.get('items') as FormArray;
  }

  addItem(data?: any) {
    this.items.push(this.fb.group({
      code: [data?.code || '', Validators.required],
      description: [data?.description || ''],
      quantity: [data?.quantity || 0],
      unitPrice: [data?.unitPrice || 0],
      amount: [data?.amount || 0],
    }));
  }

  removeItem(index: number) {
    this.items.removeAt(index);
  }

  loadData() {
    const dummyData = {
      client: { name: 'ABC Corp', address: '123 Street' },
      vendor: { name: 'XYZ Ltd', address: '456 Road', gstin: '22ABCDE1234F1Z5', pan: 'ABCDE1234F' },
      items: [
        { code: 'ITM001', description: 'Item 1', quantity: 2, unitPrice: 500, amount: 1000 },
        { code: 'ITM002', description: 'Item 2', quantity: 1, unitPrice: 1500, amount: 1500 },
      ],
      summary: { subTotal: 2500, cgst: 5, sgst: 5, igst: 0, total: 2750 }
    };

    // Add items before patching
    dummyData.items.forEach(item => this.addItem(item));

    // Patch other data
    this.workOrderForm.patchValue({
      client: dummyData.client,
      vendor: dummyData.vendor,
      summary: dummyData.summary
    });
  }

  onSubmit() {
    if (this.workOrderForm.valid) {
      console.log('Form Submitted:', this.workOrderForm.value);
    } else {
      console.warn('Form Invalid');
    }
  }
}
//   workOrderForm!: FormGroup;
//   mode: 'add' | 'edit' | 'view' = 'add';

//   gstRates = [0, 5, 12, 18, 28];

//   constructor(private fb: FormBuilder) {}

//   ngOnInit(): void {
//     this.initForm();
//     if (this.mode === 'edit') {
//       this.patchDummyData(); // optional dummy data
//     }
//   }

//   initForm() {
//     this.workOrderForm = this.fb.group({
//       issueDate: ['', Validators.required],
//       purchaseOrderNo: ['', Validators.required],
//       client: this.fb.group({
//         name: ['', Validators.required],
//         address: ['', Validators.required],
//         contact: ['', Validators.required]
//       }),
//       vendor: this.fb.group({
//         name: ['', Validators.required],
//         address: ['', Validators.required],
//         gstin: ['', Validators.required],
//         pan: ['', Validators.required],
//         contact: ['', Validators.required]
//       }),
//       items: this.fb.array([this.createItem()]),
//       taxes: this.fb.group({
//         cgst: [0],
//         sgst: [0],
//         igst: [0],
//         others: [0]
//       }),
//       shipping: [0],
//       notes: [''],
//       amountInWords: [''],
//        summary: this.fb.group({
//     subTotal: [0, Validators.required],
//     cgst: [0],
//     sgst: [0],
//     igst: [0],
//     tax1: [0],
//     tax2: [0],
//     others: [0],
//     total: [0]
//   }),
//     });
//   }

//   createItem(): FormGroup {
//     return this.fb.group({
//       itemCode: ['', Validators.required],
//       description: ['', Validators.required],
//       quantity: [0, [Validators.required, Validators.min(1)]],
//       unitPrice: [0, [Validators.required, Validators.min(0)]],
//       amount: [{ value: 0, disabled: true }]
//     });
//   }

//   get items(): FormArray {
//     return this.workOrderForm.get('items') as FormArray;
//   }

//   addItem() {
//     this.items.push(this.createItem());
//   }

//   removeItem(index: number) {
//     if (this.items.length > 1) {
//       this.items.removeAt(index);
//     }
//   }

//   calculateAmount(index: number) {
//     const item = this.items.at(index);
//     const quantity = item.get('quantity')?.value || 0;
//     const price = item.get('unitPrice')?.value || 0;
//     const amount = quantity * price;
//     item.get('amount')?.setValue(amount);
//   }

//   get subtotal(): number {
//     return this.items.controls.reduce((total, item) => {
//       return total + (item.get('amount')?.value || 0);
//     }, 0);
//   }

//   get totalGST(): number {
//     const tax = this.workOrderForm.get('taxes')?.value || {};
//     const gst = ((this.subtotal * (tax.cgst || 0)) / 100) +
//                 ((this.subtotal * (tax.sgst || 0)) / 100) +
//                 ((this.subtotal * (tax.igst || 0)) / 100);
//     return gst;
//   }

//   get grandTotal(): number {
//     const tax = this.workOrderForm.get('taxes')?.value || {};
//     const others = tax.others || 0;
//     const shipping = this.workOrderForm.get('shipping')?.value || 0;
//     return this.subtotal + this.totalGST + others + shipping;
//   }

//   setMode(newMode: 'add' | 'edit' | 'view') {
//     this.mode = newMode;
//     if (this.mode === 'view') {
//       this.workOrderForm.disable();
//     } else {
//       this.workOrderForm.enable();
//     }
//   }

//   patchDummyData() {
//     this.workOrderForm.patchValue({
//       issueDate: '2025-05-14',
//       purchaseOrderNo: 'PO-123456',
//       client: {
//         name: 'ABC Ltd',
//         address: '123 Client St, City',
//         contact: 'client@example.com'
//       },
//       vendor: {
//         name: 'XYZ Supplies',
//         address: '456 Vendor Ave',
//         gstin: 'GSTIN1234',
//         pan: 'ABCDE1234F',
//         contact: 'vendor@example.com'
//       },
//       shipping: 100,
//       notes: 'Handle with care',
//       taxes: {
//         cgst: 9,
//         sgst: 9,
//         igst: 0,
//         others: 50
//       },
//       amountInWords: 'Two Thousand Five Hundred Only'
//     });

//     this.items.clear();
//     const dummyItems = [
//       { itemCode: 'ITEM1', description: 'Excavator', quantity: 2, unitPrice: 500 },
//       { itemCode: 'ITEM2', description: 'Cement Bag', quantity: 10, unitPrice: 50 }
//     ];
//     dummyItems.forEach(item => {
//       const newItem = this.createItem();
//       newItem.patchValue(item);
//       const amount = item.quantity * item.unitPrice;
//       newItem.get('amount')?.setValue(amount);
//       this.items.push(newItem);
//     });
//   }

//   onSubmit() {
//     if (this.workOrderForm.invalid) {
//       this.workOrderForm.markAllAsTouched();
//       return;
//     }

//     const formData = this.workOrderForm.getRawValue();
//     console.log('Submitted Work Order:', formData);
//     alert('Work order submitted successfully!');
//   }
// }